<div>
    <div class="content">
        <div class="logo">
            <ui-logo [small]="true"></ui-logo>
        </div>
        @if (failed()) {
            <div class="title">
                <h1
                    nuiTypography="nui-heading"
                    uiSize="lg">
                    Sign-In Did Not Complete
                </h1>
            </div>
            <div class="text">
                <ui-label
                    >The sign-in did not complete, so the connection has not been tested. Try again, and
                    contact support if it keeps happening.</ui-label
                >
            </div>
        } @else if (!ready()) {
            <ui-loader></ui-loader>
        } @else {
            <div class="title">
                <h1
                    nuiTypography="nui-heading"
                    uiSize="lg">
                    {{ heading() }}
                </h1>
            </div>
            <div class="text">
                <ui-label>{{ message() }}</ui-label>
            </div>
            <div class="details">
                <div class="row">
                    <ui-label type="secondary">Connection</ui-label>
                    <ui-label weight="bold">{{ connection() }}</ui-label>
                </div>
                <div class="row">
                    <ui-label type="secondary">Email</ui-label>
                    <ui-label weight="bold">{{ hasEmail() ? email() : "Not provided" }}</ui-label>
                </div>
            </div>
        }
    </div>
</div>
